module.exports = __webpack_public_path__ + "static/series_2050-6fa1dfd03f1d4e3afa13ae2c5689d478.png";